<div>
	<h2
		class="p-8 text-3xl font-extrabold leading-10 tracking-tight
		text-thatBlue-800 sm:text-4xl sm:leading-none md:text-5xl">
		<slot />
	</h2>
</div>
